import { defineMessages } from 'react-intl';

import ShipsuranceLogo from './images/shipsurance-icon-color.svg';
import XcoverLogo from './images/xcover.svg';
import ParcelGuardLogo from './images/parcelguard.png';
import ParcelGuardIcon from './images/parcelguard-icon.svg';

/**
 * @typedef {import('./insurance-provider').InsuranceProvider} InsuranceProvider
 */

const messages = defineMessages({
  none: {
    description: 'insurance.none',
    defaultMessage: 'None',
    id: 'GXOzTn',
  },
  shipsurance: {
    description: 'insurance.shipsurance',
    defaultMessage: 'Shipsurance',
    id: '+h9qvD',
  },
  carrier: {
    description: 'insurance.carrier',
    defaultMessage: 'Carrier',
    id: 'XJiqiz',
  },
  external: {
    description: 'insurance.external',
    defaultMessage: 'External',
    id: '+GCS0E',
  },
  xcover: {
    description: 'insurance.xcover',
    defaultMessage: 'Total Shipping Protection',
    id: 'NuXuTz',
  },
  parcelGuard: {
    description: 'ParcelGuard insurance',
    defaultMessage: 'ParcelGuard',
    id: 'fMzQMP',
  },
  parcelGuardFulfillmentPlanner: {
    description: 'ParcelGuard insurance as shown in insurance drop down in the csw',
    defaultMessage: 'Insurance by ParcelGuard',
    id: 'j7OgqK',
  },
});

/**
 * @type {Record<'None' | 'Shipsurance' | 'XCover' | 'ParcelGuard' | 'Carrier' | 'External', InsuranceProvider>}
 */
export const InsuranceProviders = {
  None: {
    insuranceProviderId: '0',
    messageDescriptor: messages.none,
    name: 'None',
  },
  Shipsurance: {
    insuranceProviderId: '1',
    logoUrl: ShipsuranceLogo,
    messageDescriptor: messages.shipsurance,
    name: 'Shipsurance',
    canFileAClaim: true,
  },
  // XCover and ParcelGuard are out of order (according to the insuranceProviderId) to control their order in
  // the multiline insurance input dropdown
  XCover: {
    insuranceProviderId: '4',
    logoUrl: XcoverLogo,
    messageDescriptor: messages.xcover,
    name: 'XCover',
    canFileAClaim: true,
  },
  ParcelGuard: {
    insuranceProviderId: '5',
    logoUrl: ParcelGuardLogo,
    iconUrl: ParcelGuardIcon,
    messageDescriptor: messages.parcelGuard,
    insurancePromoEnabledMessageDescriptor: messages.parcelGuardFulfillmentPlanner,
    name: 'ParcelGuard',
    canFileAClaim: true,
  },
  Carrier: {
    insuranceProviderId: '2',
    messageDescriptor: messages.carrier,
    name: 'Carrier',
  },
  External: {
    insuranceProviderId: '3',
    messageDescriptor: messages.external,
    name: 'External',
  },
};

export const UNSUPPORTED_DESTINATION = 'unsupported destination';

export const getInsuranceProviderById = (_insuranceProviderId) =>
  Object.values(InsuranceProviders).find(({ insuranceProviderId }) => insuranceProviderId === _insuranceProviderId);

export const getInsuranceProviderByName = (insuranceProviderName) => {
  return Object.values(InsuranceProviders).find((p) => p.name === insuranceProviderName);
};
